export const PAGE_SIZE_OPTIONS = [50, 100, 250, 500];
